import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromApp from '../store/app.reducer';
import { logout } from './store/auth.actions'; // ✅ Import function-based action

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private tokenExpirationTimer: ReturnType<typeof setTimeout> | null = null; // ✅ Corrected TypeScript typing

  constructor(private store: Store<fromApp.AppState>) {}

  setLogoutTimer(expirationDuration: number) {
    this.tokenExpirationTimer = setTimeout(() => {
      this.store.dispatch(logout()); // ✅ Use function-based action
    }, expirationDuration);
  }

  clearLogoutTimer() {
    if (this.tokenExpirationTimer) {
      clearTimeout(this.tokenExpirationTimer);
      this.tokenExpirationTimer = null;
    }
  }
}
